import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';

import { DeviceActiveSyncsEffects } from './devices-active-syncs.effects';
import { deviceActiveSyncsReducer } from './devices-active-syncs.reducer';

export const provideDeviceActiveSyncsStore = () => [
  provideState('deviceActiveSyncsState', deviceActiveSyncsReducer),
  provideEffects([DeviceActiveSyncsEffects]),
];
